import { Link } from "react-router-dom";
import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useHomeData } from "../../../lib/useMockData";

export default function ReviewsSection() {
  const { reviewsData } = useHomeData();
  return (
    <section className="py-20 md:py-28 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12">
              <p className="section-label mb-3">{reviewsData.label}</p>
              <h2 className="section-title">{reviewsData.title}</h2>
              <p className="section-subtitle">{reviewsData.subtitle}</p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {reviewsData.items.map((item, idx) => (
              <ScrollReveal key={item.name} direction="up" delay={idx * 100}>
                <div className="p-7 bg-airdoa-cream rounded-lg h-full">
                  <div className="flex items-center gap-1 mb-4">
                    {Array.from({ length: item.rating }).map((_, i) => (
                      <span key={i} className="w-4 h-4 flex items-center justify-center text-airdoa-gold">
                        <i className="ri-star-fill text-sm" />
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-airdoa-navy leading-relaxed">{item.comment}</p>
                  <div className="mt-5 pt-5 border-t border-airdoa-gray-light/50 flex items-center justify-between">
                    <div>
                      <p className="text-sm font-medium text-airdoa-navy">{item.name}</p>
                      <p className="text-xs text-airdoa-gray">{item.age}</p>
                    </div>
                    <span className="px-2.5 py-1 text-[10px] font-medium text-airdoa-gold bg-white rounded">
                      {item.scene}
                    </span>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal direction="up" delay={200}>
            <div className="mt-10 text-center">
              <Link to="/reviews" className="btn-secondary">
                お客様の声をもっと見る
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}